import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('sequentialLiability',  {
    bindings: {
      formName: '@',
      sequentialLiabilityApproved: '<',
      creditLimit: '<'
    },
    template: require("../templates/sequentialLiability.html"),
    controllerAs: '$sequentialLiabilityCtrl',
    controller: ['$rootScope', function($rootScope) {

      var self = this;

      this.approvedOptions = componentHelper.approvedOptions();

      this.setSequentialLiabilityApproved = function(sequentialLiabilityApproved) {
        if (sequentialLiabilityApproved === self.sequentialLiabilityApproved) {
          return;
        }

        self.sequentialLiabilityApproved = sequentialLiabilityApproved;
      };
    }]
});
